import { render, staticRenderFns } from "./ProvidersTag.vue?vue&type=template&id=32724202"
import script from "./ProvidersTag.vue?vue&type=script&lang=js"
export * from "./ProvidersTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports